import styled from 'styled-components';

const PriceContainer = styled.div`
  overflow: hidden;

  .rhcTooltipContainer {
    min-width: 350px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    width: 100%;
    margin-bottom: 10px;

    > p {
      color: #abb5be;
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-weight: 600;
    }
  }
  .rhcTooltipValues {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 75%;

    p {
      margin-left: 5px;
    }
  }
  .rhcTooltipValues > * {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 33%;
    text-align: center;
  }
  .rhcTooltipValues > div:not(:last-child) {
    margin-right: 15px;
  }

  .rhcTooltip {
    padding: 12px;
    min-width: 250px;
  }
  .rhcDate {
    color: #abb5be;
    text-transform: uppercase;
  }
  .rhcLabel {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;

    .rightComponents {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: auto;
    }

    .rightComponents > *:not(:last-child) {
      margin-right: 10px;
    }
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .headerInputsContainer {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};

    .label {
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
      margin-right: 20px;
      margin-bottom: 0px;
    }
  }

  .headerInputsContainer > *:not(:last-child) {
    margin-right: 10px;
  }

  .selectSetsContainer {
    margin-top: 50px;
    width: 100%;
  }

  .selecSetstInputContainer {
    width: 70%;
    margin-left: 15%;
  }

  .setListContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    margin-top: 5px;

    > div {
      margin: 0 !important;
      height: 30px !important;
      white-space: nowrap !important;
      width: initial !important;
    }

    .tag {
      width: initial !important;
    }

    > div:not(:last-child) {
      margin-right: 10px !important;
    }
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    .rightComponentsContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: 10px !important;
    }
  }
`;

export default PriceContainer;
